import * as React from 'react';
import { MsalProvider, useIsAuthenticated } from '@azure/msal-react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// We use relative imports. So anytime you want to import something from another dir, you can just speicfy that specific dir along with a @, no need to worry about relative paths
import Chat from '@routes/Chat';
import Login from '@routes/Login';
import Feedback from '@routes/Feedback'
import ExamMode from '@routes/ExamMode';
import Dashboard from '@routes/Dashboard'
import { msalInstance, initializeMsal } from '@auth/msalConfig';
import * as ReactDOM from 'react-dom/client';
import '@styles/index.css';

initializeMsal().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});

const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/chat" element={<PrivateRoute component={Chat} />} />
      <Route path="/feedback" element={<PrivateRoute component={Feedback} />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/exam-mode" element={<ExamMode />} />
    </Routes>
  </Router>
);



const PrivateRoute = ({ component: Component }) => {
  const isAuthenticated = useIsAuthenticated();

  return isAuthenticated ? <Component /> : <Navigate to="/" />;
};

export default App;
